import {Chip} from "@mui/material";

export const SEGMENT_COLORS = {
    'Champions':            {bg: '#2E7D32', fg: '#fff'},
    'Loyal':                {bg: '#8BC34A', fg: '#1b5e20'},
    'Potential Loyalists':  {bg: 'rgb(187, 214, 238)', fg: '#0d47a1'},
    'New Customers':        {bg: 'rgb(68, 114, 196)', fg: '#fff'},
    'Promising':            {bg: 'rgb(236, 239, 241)', fg: '#263238'},
    'Need Attention':       {bg: 'rgb(255, 192, 0)', fg: '#37474F'},
    'At Risk':              {bg: '#F44336', fg: '#fff'},
    'Hibernating':          {bg: '#FFEB3B', fg: '#795548'},
    'Lost':                 {bg: '#9E9E9E', fg: '#fff'}
};

export const SegmentChip = ({segment}) => {
    if (!segment) return null;
    const colors = SEGMENT_COLORS[segment] || {bg: '#607D8B', fg: '#fff'};
    return <Chip size="small" label={segment} style={{background: colors.bg, color: colors.fg, fontWeight: 600}}/>;
};
